import React from 'react'
import { Link } from "react-router-dom";

const AirTransportation = () => {
    return (
        <>

            <div style={{ overflow: "hidden" }}>
                <section className="section-breadcrumb main-wrapper">
                    <div className="breadcrumb-area">
                        <div className="container">
                            <div className="breadcrumb-wrapper">
                                <nav className="breadcrumb">
                                    <Link className="breadcrumb-item" to="/">Home</Link>
                                    <span className="breadcrumb-item active" aria-current="page">Services</span>
                                </nav>
                                <h1 className="breadcrumb-title">View All Services</h1>
                            </div>
                            <div className="breadcrumb-bg-block">
                                <img src="assets/images/breadcrumb-bg.jpg" alt="breadcrumb-bg" width={1920} height={448} className="img-cover" />
                                <img src="assets/images/breadcrumb-shape.png" alt="breadcrumb-shape" width={1033} height={448} />
                            </div>
                        </div>
                    </div>
                </section>
                <div className="section-service-details">
                    <div className="section-space">
                        <div className="container">
                            <div className="row g-lg-5">
                                <div className="col-md-6 col-lg-7 col-xl-8">
                                    <div className="mb-4">
                                        <img src="assets/images/service-details-hero-img.jpg" alt="service-details-hero-img" width={905} height={546} className="img-fluid rounded" />
                                    </div>
                                    <article className="text-rich">
                                        <h2>Air Transportation</h2>
                                        <p> Rahul Logistics, a Katni-based company, recognizes the value of promptness and dependability in the delivery of your vital cargo. For both domestic and international deliveries, our air cargo services in Katni provide effective and safe air freight options. Our Air Express services guarantee that your shipments always arrive at their destination on schedule, regardless of whether you need to transport high-value items, urgent deliveries, or time-sensitive cargo.</p>
                                        <p> By utilizing a worldwide network of air carriers and cutting-edge tracking technology, Rahul Logistics provides you with a logistics partner with extensive experience in air freight. Our staff is dedicated to offering complete solutions that seamlessly and precisely satisfy your business needs while providing outstanding customer service. </p>
                                        
                                       
                                        <ul className="content-list content-list-1 flex-wrap d-flex row-gap-2 column-gap-5 flex-wrap">
                                            <li>On-Time Delivery</li>
                                            <li>Real-Time Tracking</li>
                                            <li>Competitive Pricing</li>
                                            <li>Nationwide Coverage </li>
                                            <li>Advanced Technology</li>
                                            <li>24/7 Customer Support</li>
                                            <li>Customer-Centric Approach</li>
                                        </ul>
                                    </article>
                                </div>
                                <div className="col-md-6 col-lg-5 col-xl-4">
                                    <aside>
                                        <ul className="sidebar-list">
                                            <li className="sidebar-banner">
                                                <img src="assets/images/sidebar-banner-img.jpg" alt="sidebar-banner-img" width={368} height={546} className="img-cover" />
                                                <div className="inner-content">
                                                    {/* <span className="fs-5">Start Your Projects</span> */}
                                                    <div className="service-banner-info-block">
                                                        <ul className="get-touch-info-list">
                                                            <li>
                                                                <div className="icon">
                                                                    <i className="fa-light fa-phone" />
                                                                </div>
                                                                <div className="content">
                                                                    <span>24/7 Our Support</span>
                                                                    <a href="tel:+91 8770252599" className="text-white">+91 8770252599</a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            {/* Sidebar Item - Banner*/}
                                        </ul>
                                    </aside>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default AirTransportation